import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Estrutura from "../pages/estrutura/page";
import Modalidades from "../pages/modalidades/page";
import Horarios from "../pages/horarios/page";
import Localizacao from "../pages/localizacao/page";
import Contato from "../pages/contato/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/estrutura",
    element: <Estrutura />,
  },
  {
    path: "/modalidades",
    element: <Modalidades />,
  },
  {
    path: "/horarios",
    element: <Horarios />,
  },
  {
    path: "/localizacao",
    element: <Localizacao />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;